import React from "react";
import { Box, Typography } from "@mui/material";

type IconTint = "positive" | "neutral";

interface Props {
  icon: React.ReactNode;
  iconTint?: IconTint;
  label: string;
  primaryValue: React.ReactNode;
  secondaryValue?: React.ReactNode;
  testId?: string;
}

export const AccordionSummaryHeader = ({
  icon,
  iconTint = "neutral",
  label,
  primaryValue,
  secondaryValue,
  testId,
}: Props) => {
  const isPositive = iconTint === "positive";
  return (
    <Box display="flex" alignItems="center" gap={3} data-testid={testId}>
      <Box
        width={32}
        height={32}
        borderRadius={1.5}
        display="grid"
        bgcolor={isPositive ? "background.success" : "background.subtle"}
        color={isPositive ? "text.positive" : "text.secondary"}
        sx={{ placeItems: "center", flexShrink: 0 }}
      >
        {icon}
      </Box>
      <Box flex={1} minWidth={0}>
        <Typography variant="body4" color="textSecondary">
          {label}
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          flexWrap="wrap"
          mt={0.5}
        >
          {primaryValue}
          {secondaryValue}
        </Box>
      </Box>
    </Box>
  );
};
